@for (element of elements; track element.id) {
  @switch (element.elementLayout) {

    @case (layoutType.FIELD) {
      <ng-template visiblewhen [layoutObject]="element.field" [model]="model" [specFields]="specFields">
        @if (!element.field.cfgHidden) {
          <lm-field
            [layoutObject]="element.field"
            [layoutInfo]="layoutInfo"
            [lmColumnLayoutInfo]="lmColumnLayoutInfo"
            [specFields]="specFields"
            [placeHolder]="placeHolder"
            [model]="model"
            class="{{element.class}}"
            (fieldEvent)="onFieldEvent($event)"
          ></lm-field>
        }
      </ng-template>
    }

    @case (layoutType.CHECK_CONTROL) {
      <ng-template visiblewhen [layoutObject]="element.checkcontrol" [model]="model" [specFields]="specFields">
        @if (!element.checkcontrol.cfgHidden) {
          <lm-checkcontrol
            [layoutObject]="element.checkcontrol"
            [specFields]="specFields"
            [placeHolder]="placeHolder"
            [model]="model"
            [layoutInfo]="layoutInfo"
            [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
            [lmColumnLayoutInfo]="lmColumnLayoutInfo"
            class="{{element.class}} || field"
            (fieldEvent)="onFieldEvent($event)"
          ></lm-checkcontrol>
        }
      </ng-template>
    }


    @case (layoutType.CAPTCHA_CONTROL) {
      <ng-template visiblewhen [layoutObject]="element.captchaControl" [model]="model" [specFields]="specFields">
        <lm-captcha-control [layoutObject]="element.captchaControl"></lm-captcha-control>
      </ng-template>
    }

    @case (layoutType.HEADER) {
      <ng-template visiblewhen [layoutObject]="element.header" [model]="model" [specFields]="specFields">
        <lm-header
          [layoutObject]="element.header"
          [layoutInfo]="layoutInfo"
          [specFields]="specFields"
          [model]="model"
          [previousSiblingIsCollapsible]="element.previousSiblingIsCollapsibleHeader"
          class="{{element.class}}"
          (fieldEvent)="onFieldEvent($event)"
        ></lm-header>
      </ng-template>
    }

    @case (layoutType.MANUAL_REPRESENTATION) {
      <ng-template visiblewhen [layoutObject]="element.manualrep" [model]="model" [specFields]="specFields">
          <lm-manual-representation
              [manualRep]="element.manualrep"
              class="{{element.class}}"
              [model]="model"
              (fieldEvent)="onFieldEvent($event)"
          ></lm-manual-representation>
      </ng-template>
    }

    @case (layoutType.PARAGRAPH) {
      <lm-paragraph
        [layoutObject]="element.paragraph"
        [layoutInfo]="layoutInfo"
        [lmColumnLayoutInfo]="lmColumnLayoutInfo"
        [specFields]="specFields"
        [placeHolder]="placeHolder"
        [model]="model"
        class="{{element.class}}"
        (fieldEvent)="onFieldEvent($event)"
      ></lm-paragraph>
    }

    @case (layoutType.BUTTON) {
      <ng-template visiblewhen [layoutObject]="element.button" [model]="model" [specFields]="specFields">
        @if (!element.button.cfgHidden) {
          <lm-button
            [layoutObject]="element.button"
            [specFields]="specFields"
            [model]="model"
            [layoutInfo]="layoutInfo"
            [lmColumnLayoutInfo]="lmColumnLayoutInfo"
            class="{{element.class}}"
            (fieldEvent)="onFieldEvent($event)"
          ></lm-button>
        }
      </ng-template>
    }

    @case (layoutType.BLANK) {
      <ng-template visiblewhen [layoutObject]="element.Blank" [model]="model" [specFields]="specFields">
        @if (lmColumnLayoutInfo) {
          <div
              lm-blankline
              class="{{element.class}}"
          >
          </div>
        }
        @if (!lmColumnLayoutInfo) {
          <div lm-blankline></div>
        }
      </ng-template>
    }

    @case (layoutType.TEXT) {
      <ng-template visiblewhen [layoutObject]="element.text" [model]="model" [specFields]="specFields">
        <lm-text
          [layoutObject]="element.text"
          [specFields]="specFields"
          [placeHolder]="placeHolder"
          [layoutInfo]="layoutInfo"
          [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
          [lmColumnLayoutInfo]="lmColumnLayoutInfo"
          [model]="model"
          class="{{element.class}}"
          (fieldEvent)="onFieldEvent($event)"
        ></lm-text>
      </ng-template>
    }

    @case (layoutType.MENU) {
      <ng-template visiblewhen [layoutObject]="element.menu" [model]="model" [specFields]="specFields">
        <lm-simple-card
          [automationId]="element.menu.automationId"
          [type]="element.menu.type"
          [specFields]="specFields"
          [model]="model"
          [scale]="element.menu.menuScale"
          [link]="element.menu.link"
          [showBackground]="false"
          [imageUrl] = "element.menu.image"
          [title]="element.menu.label"
          [description]="element.menu.description"
          [paragraphLayout]="false"
          [isLink]="element.menu.isLink"
          [isExternalLink]="element.menu.external"
          [allowScannableSearch]="element.menu.allowScannableSearch"
          [openWhenSingleResult]="element.menu.openWhenSingleResult"
          class="{{element.class}} field"
          (fieldEvent)="onFieldEvent($event)"
        ></lm-simple-card>
      </ng-template>
    }
  }
}